var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.359,
    height: 43.841,
    viewBox: "0 0 46.359 43.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.492,
    y1: 1.001,
    x2: 0.492,
    y2: 0.002,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93eaf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.497,
    y1: 1,
    x2: 0.497,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b537d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76709a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.492,
    y1: 1,
    x2: 0.492,
    y2: 0.001,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8224",
    "data-name": "Path 8224",
    d: "M8.44,28.31l-2-3.79h0a1,1,0,0,0-1.85,0h0l-2.1,3.9a2.91,2.91,0,0,0-.23.42h0a3.47,3.47,0,0,0-.3,1.44,3.58,3.58,0,1,0,6.53-2Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8225",
    "data-name": "Path 8225",
    d: "M40.41,16.4h-.23a7.52,7.52,0,0,0,.18-1.59,7.28,7.28,0,0,0-7.28-7.28h0a7.26,7.26,0,0,0-1.82.24A11.59,11.59,0,0,0,8.78,10.39H8.71A8.71,8.71,0,0,0,0,19.1H0a8.71,8.71,0,0,0,8.71,8.71h31.7a5.71,5.71,0,1,0,0-11.41Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    "data-name": "Path 8226",
    d: "M28.21,38.23l-2-3.78h0a1,1,0,0,0-1.85,0h0l-2.1,3.89a2.55,2.55,0,0,0-.23.43h0a3.44,3.44,0,0,0-.3,1.44,3.58,3.58,0,1,0,6.53-2Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M22.06,28.51H20.37l1.2-1.2a1,1,0,1,0-1.42-1.41L19,27.1V25.4a1,1,0,0,0-2,0v1.7l-1.19-1.2a1,1,0,0,0-1.42,1.41l1.2,1.2H13.85a1,1,0,0,0,0,2h1.69l-1.2,1.2a1,1,0,1,0,1.42,1.41L17,31.92v1.7a1,1,0,0,0,2,0v-1.7l1.2,1.2a1,1,0,0,0,1.42-1.41l-1.2-1.2h1.69a1,1,0,0,0,0-2Z",
    fill: "#93eaf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    "data-name": "Path 8228",
    d: "M43.93,33.86H42.24l1.2-1.2a1,1,0,1,0-1.42-1.41l-1.2,1.2v-1.7a1,1,0,0,0-2,0v1.7l-1.19-1.2a1,1,0,1,0-1.42,1.41l1.2,1.2H35.72a1,1,0,0,0,0,2h1.69l-1.2,1.2a1,1,0,1,0,1.42,1.41l1.19-1.2V39a1,1,0,0,0,2,0V37.3l1.2,1.2a1,1,0,0,0,1.42-1.41l-1.2-1.2h1.69a1,1,0,0,0,0-2Z",
    fill: "#93eaf8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMix);
export default __webpack_public_path__ + "static/media/Mix.2875a6e09cc28e81025156f7336d631f.svg";
export { ForwardRef as ReactComponent };